export const overlayStore = {
    state: {
        popupOpen: false,
        showPopupDeal: true,
        showReturnPopup: null,
        showVideoPopup: false,
    },
    openPopupOverlay() {
        this.state.popupOpen = true;
    },
    toggleVideoPopup() {
        this.state.showVideoPopup = !this.state.showVideoPopup;
    },
};
